// SPEC-041: the one-time code login lives on its own route. The flow (which
// email, where it started, where to return) travels in router state rather
// than redux: the auth slice is persisted to localStorage, and a flow stored
// there survived refreshes and re-sent the code on every reload.

export const OTP_LOGIN_PATH = '/login/otp'

/**
 * Build the route state for the OTP login page.
 *
 * `next` is where the standard post-login handling sends the user: back into
 * checkout (current URL) when the flow started there, otherwise whatever the
 * login page had already been told to return to, if anything.
 */
export const otpLoginState = ({ email, trigger, inCheckout = false, location }) => ({
  email,
  trigger,
  inCheckout,
  next: inCheckout
    ? `${location.pathname}${location.search || ''}`
    : location?.state?.next
})
